
export type CreateNotification201BasicInfoType = typeof CreateNotification201BasicInfoType[keyof typeof CreateNotification201BasicInfoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateNotification201BasicInfoType = {
  LIKE: 'LIKE',
  REPLY: 'REPLY',
  RETWEET: 'RETWEET',
  FOLLOW: 'FOLLOW',
  MENTION: 'MENTION',
} as const;
